export enum ButtonVariantEnum {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    TERTIARY = 'tertiary',
    QUATERNARY = 'quaternary',
    QUINARY = 'quinary',
    SENARY = 'senary',
    DANGER = 'danger',
    DANGER_OUTLINE = 'danger-outline',
    METAMASK = 'metamask',
    COINBASE = 'coinbase',
    LINKEDIN = 'linkedin',
    ALT_PRIMARY = 'alt-primary',
    ALT_PRIMARY_DARK = 'alt-primary-dark',
    INVERTED = 'inverted',
}
